import type { FC } from 'react';
import { Image } from '@chakra-ui/react';

import hornImg from 'assets/brand/horn.png';
import Heading from 'components/_core/Heading';
import Text from 'components/_core/Text';
import DetailSidebar, { DetailSidebarProps } from 'components/DetailSidebar';

import locales from './locales';

type Props = Omit<DetailSidebarProps, 'children'> & {
  employeeName: string;
};

const DetailSidebarRejected: FC<Props> = ({ employeeName, ...props }) => (
  <DetailSidebar {...props} variant="ghost">
    <DetailSidebar.Header />
    <DetailSidebar.Body gap="space-8">
      <Image alt="" role="presentation" src={hornImg} width="80px" />
      <Heading>{locales.heading}</Heading>
      <Text>
        {locales.formatString(locales.description, {
          employeeName,
        })}
      </Text>
    </DetailSidebar.Body>
  </DetailSidebar>
);

export default DetailSidebarRejected;
